module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "print"
    }
  }, _vm._l((_vm.printData), function(data) {
    return (_vm.printData && _vm.printData.length) ? _c('div', {
      staticClass: "body"
    }, [_c('div', {
      staticClass: "header"
    }, [_c('div', {
      staticClass: "elem left"
    }, [_c('label', [_vm._v("№")]), (data.freight_tracking) ? _c('div', {
      staticClass: "freight-tracking-number"
    }, [_vm._v(_vm._s(data.freight_tracking))]) : _vm._e()]), (data.seat_number) ? _c('div', {
      staticClass: "elem right"
    }, [_c('label', [_vm._v(_vm._s(data.seat_number + ' из ' + data.seats_number))])]) : _vm._e()]), _c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "text"
    }, [(data.created_at) ? _c('div', {
      staticClass: "date text-item"
    }, [_c('div', [_vm._v("Дата приёма:")]), _c('b', [_vm._v(_vm._s(data.created_at))])]) : _vm._e(), (data.from_city) ? _c('div', {
      staticClass: "from text-item"
    }, [_c('div', [_vm._v("Отправление:")]), _c('b', [_vm._v(_vm._s(data.from_city))])]) : _vm._e(), (data.to_city) ? _c('div', {
      staticClass: "to text-item"
    }, [_c('div', [_vm._v("Назначение:")]), _c('b', [_vm._v(_vm._s(data.to_city))])]) : _vm._e(), (data.recipient) ? _c('div', {
      staticClass: "to text-item"
    }, [_c('div', [_vm._v("Получатель:")]), _c('b', [_vm._v(_vm._s(_vm.mb_strimwidth(data.recipient, 0, 50, '...')))])]) : _vm._e(), (data.temperatureRegime) ? _c('div', {
      staticClass: "regime text-item"
    }, [_c('b', [_vm._v("Т")])]) : _vm._e()]), _c('div', {
      staticClass: "qr"
    }, [_c('canvas', {
      ref: data.ref,
      refInFor: true
    })])])]) : _vm._e()
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07d9dc7a","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/storekeepers_stocks/views/print/FreightTicketPrint.vue
// module id = 1030
// module chunks = 0